import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {Alert, Button, TextField} from '@betareader/design-system';
import {push} from '../../navigation';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import genres from '../../shared/constants/genres';
import {updateUserProfile} from '../../modules/user';

export class NewUser extends Component {
  state = {displayName: '', preferredGenres: [], motivation: ''};

  saveDisplayName = event => {
    event.preventDefault();
    const displayName = this.state.displayName.trim();
    if (displayName) this.props.updateUserProfile(this.props.idToken, {displayName});
  };

  saveRole = role => {
    this.props.updateUserProfile(this.props.idToken, {role});
  };

  savePreferredGenres = () => {
    if (this.state.preferredGenres.length) {
      this.props.updateUserProfile(this.props.idToken, {
        preferredGenres: this.state.preferredGenres
      });
    }
  };

  saveReceiveEmails = receiveEmails => {
    this.props.updateUserProfile(this.props.idToken, {receiveEmails});
  };

  saveMotivation = event => {
    event.preventDefault();
    const motivation = this.state.motivation.trim();
    if (motivation) this.props.updateUserProfile(this.props.idToken, {motivation});
  };

  render() {
    const {userProfile = {}, userProfileLoaded} = this.props;
    const {displayName, role, preferredGenres, receiveEmails, motivation} = userProfile;
    if (!userProfileLoaded) return <p role='status'>Loading…</p>;

    let step;
    if (displayName === undefined) {
      step = (
        <>
          <Alert>Great! Now, tell us a bit about you.</Alert>
          <form onSubmit={this.saveDisplayName} style={{display: 'grid', gap: '1rem'}}>
            <TextField id='new-user-name' label='What is your name?' required
              value={this.state.displayName}
              onChange={event => this.setState({displayName: event.target.value})} />
            <Button type='submit' disabled={!this.state.displayName.trim()}>Next</Button>
          </form>
        </>
      );
    } else if (role === undefined) {
      step = (
        <>
          <Alert>Thanks, {displayName}! Are you a reader or a writer?</Alert>
          <div role='group' aria-label='Choose your role' style={{display: 'flex', flexWrap: 'wrap', gap: '.5rem'}}>
            <Button onClick={() => this.saveRole('WRITER')}>Writer</Button>
            <Button onClick={() => this.saveRole('BOTH')}>Both</Button>
            <Button onClick={() => this.saveRole('READER')}>Reader</Button>
          </div>
        </>
      );
    } else if (preferredGenres === undefined) {
      step = (
        <>
          <Alert>
            {role === 'WRITER' && 'A fellow writer!'}
            {role === 'READER' && 'We also love to read!'}
            {role === 'BOTH' && 'Reading and writing do go hand in hand :)'}
            {' '}Which genres do you prefer{role === 'WRITER' && ' to write in'}{role === 'READER' && ' to read'}?
          </Alert>
          <label className='br-field' htmlFor='new-user-genres'>
            <span className='br-field__label'>Preferred genres</span>
            <select id='new-user-genres' className='br-field__input' multiple size={8}
              value={this.state.preferredGenres}
              onChange={event => this.setState({
                preferredGenres: Array.from(event.target.selectedOptions, option => option.value)
              })}>
              {genres.map(genre => <option key={genre} value={genre}>{genre}</option>)}
            </select>
          </label>
          <Button disabled={!this.state.preferredGenres.length}
            onClick={this.savePreferredGenres}>Next</Button>
        </>
      );
    } else if (receiveEmails === undefined) {
      step = (
        <>
          <Alert>
            {preferredGenres[0]} is great! Almost finished now: do you want to receive emails when things change?
            {' '}{role === 'READER' && '(For example when the writer updates a chapter)'}
            {role === 'BOTH' && '(For example when a reader leaves a feedback note)'}
          </Alert>
          <div role='group' aria-label='Email updates' style={{display: 'flex', flexWrap: 'wrap', gap: '.5rem'}}>
            <Button onClick={() => this.saveReceiveEmails(true)}>Yes, please!</Button>
            <Button variant='secondary' onClick={() => this.saveReceiveEmails(false)}>No, thanks!</Button>
          </div>
        </>
      );
    } else if (motivation === undefined) {
      step = (
        <>
          <Alert>Got it! Last question: Why do you want to use BetaReader?</Alert>
          <form onSubmit={this.saveMotivation} style={{display: 'grid', gap: '1rem'}}>
            <label className='br-field' htmlFor='new-user-motivation'>
              <span className='br-field__label'>Why do you want to use BetaReader?</span>
              <textarea id='new-user-motivation' className='br-field__input' required
                placeholder='We are keen to know...' value={this.state.motivation}
                onChange={event => this.setState({motivation: event.target.value})} />
            </label>
            <Button type='submit' disabled={!this.state.motivation.trim()}>Submit</Button>
          </form>
        </>
      );
    } else {
      step = (
        <>
          <Alert>That's all!</Alert>
          <a className='br-button br-button--primary br-button--medium' href='/profile'>
            Complete account creation
          </a>
        </>
      );
    }

    return <main style={{maxWidth: 640, margin: '0 auto', padding: '1.5rem', display: 'grid', gap: '1rem'}}>{step}</main>;
  }
}

const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile,
  userProfileLoaded: state.user.userProfileLoaded
});

const mapDispatchToProps = dispatch => bindActionCreators({
  updateUserProfile,
  changePage: newPage => push(newPage)
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewUser));
